var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "map", staticClass: "stores-map" },
    [
      _vm.popupByClick
        ? [
            _c(
              "vue-client-only",
              [
                !_vm.adaptive.isDesktop
                  ? _c(
                      "modal",
                      {
                        attrs: { visible: !_vm.storeCardIsEmpty },
                        on: {
                          "on-close": function($event) {
                            return _vm.toggleStoreCard()
                          }
                        }
                      },
                      [
                        _c("store-card", {
                          attrs: {
                            "cart-button": _vm.cartButtonIsActive,
                            store: _vm.activeStoreCard
                          }
                        })
                      ],
                      1
                    )
                  : _c("store-card", {
                      attrs: {
                        "cart-button": _vm.cartButtonIsActive,
                        store: _vm.activeStoreCard
                      },
                      on: {
                        close: function($event) {
                          return _vm.toggleStoreCard()
                        }
                      }
                    })
              ],
              1
            )
          ]
        : _vm._e(),
      !_vm.isLoaded
        ? _c(
            "div",
            { staticClass: "map-loader" },
            [_c("ui-loader", { attrs: { size: "56" } })],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }